export const getGACookie = (name: string): string => {
  const nameString = name + '='

  const cookieArray = decodeURIComponent(document.cookie).split(';')

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i]

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(nameString) === 0) {
      return cookie.substring(nameString.length, cookie.length).replace(/^[^.]+\.[^.]+\./, '')
    }
  }
  return ''
}
